const nonCharStr = '[\\s\\u{00}-\\u{2F}\\u{3A}-\\u{40}\\u{5B}-\\u{60}\\u{7B}-\\u{BF}\\u{D7}\\u{F7}]+';

export function getSearchWords(str) {
    return str.split(new RegExp(nonCharStr, 'iu')).filter(w => !!w);
}

export function isMatchedByDoi(doi, str) {
    return !!(doi && str.toLowerCase().match(new RegExp(`(^|${nonCharStr})${doi}($|${nonCharStr})`, 'iu')));
}
